<template>
    <div class="youtube-video">
        <youtube
            ref="youtube"
            :video-id="videoId"
            :player-vars="options"
        />
    </div>
</template>

<script>
import _debounce from "lodash/debounce";

export default {
    name: "YoutubeVideo",
    props: {
        videoId: {
            type: String,
            required: true
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        autoplayOffset: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            options: {
                mute: 1
            }
        }
    },
    computed: {
        player() {
            return this.$refs.youtube.player;
        }
    },
    mounted() {
        if (this.autoplay) {
            document.addEventListener("scroll", this.debouncedFunction);
        }
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.debouncedFunction);
    },
    methods: {
        debouncedFunction: _debounce(function() {
            this.shouldPlayVideo();
        }),
        shouldPlayVideo() {
            if (this.isVisible()) {
                this.playVideo();
                document.removeEventListener("scroll", this.debouncedFunction);
            }
        },
        playVideo() {
            this.player.playVideo();
        },
        isVisible() {
            const bounding = this.$el.getBoundingClientRect();
            const isOnTheBottom =
                bounding.bottom <= (document.innerHeight || document.documentElement.clientHeight) + this.autoplayOffset;
            return Math.round(Math.abs(bounding.top)) <= Math.round((bounding.bottom / 1.5)) && isOnTheBottom;
        }
    }
}
</script>

<style lang="scss">
.youtube-video {
    width: 100%;
    height: 100%;

    iframe {
        width: 100%;
        height: 100%;
    }
}
</style>